/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { dateToFormat, dateToViewFormat, getFormatHour } from "../../utils/date";
import BankDetail from "../../pages/Funds/AccountDetail/BankDetail";
import ClientMappingModal from "./ClientMappingModal";
import IconButton from "../Button/IconButton";
import DeleteIcon from "../../assets/images/icon/delete-icon-01.svg";
import { deleteBanksTransClients, downloadBankAccountexcel, getBankTransRecordExcelMailSend, modifyBankTransUseConfirm } from "../../apis/finances/bank";
import systemAlert from "../../utils/systemAlert";
import { cloneDeep, findIndex, get, isEmpty } from "lodash";
import RelatedModal from "../../pages/Funds/AccountDetail/RelatedModal";
import useForm from "../../hooks/useForm";
import CategoryMappingModal from "./CategoryMappingModal";
import { deleteAccountingTitle } from "../../apis/finances/accounting-title";
import Icon from "../Icon";
import CommentIcon from "../../assets/images/icon/comment-icon.svg";
import { downExcelFile } from "../../utils/download";

import { getExcelDownParams } from "../../utils/params";
import { classnames } from "../../utils/text";
import { clientPreview } from "../../utils/client";
import { preventEvent } from "../../utils/element";
import { getFinanacesScrapingHistoryList, scrapingFinanaces } from "../../apis/finances/auth";
import { viewLoading } from "../../utils/loading";
import { useHistory } from "react-router-dom";
import EmailSendModal from "../Email/EmailSendModal";

const BankTable = ({
  title,
  api,
  params = {},
  isUseConfirm = false,
  bankAccountIdx,
  bankList,
  pbkScrapings = [],
  cbkScrapings = [],
  permission,
  scrapingPermission,
  careCompanyIdx
}) => {

  const history = useHistory();
  const [sortFields, setSortFields] = useState([
    { key: 'tradeTime', order: 'desc' },
    { key: 'inAmt', order: '' },
    { key: 'outAmt', order: '' },
    { key: 'balanceAmt', order: '' },
  ]);
  const [fields, setFields] = useState([]);
  // 상세 내역
  const [open, setOpen] = useState(false);
  const [detailFormData, setDetailFromData] = useState({});
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  // 카테고리 매핑
  const [isCategoryMappingOpen, setIsCategoryMappingOpen] = useState(false);
  // 관련내역 일괄 등록
  const [relatedListOpen, setRelatedListOpen] = useState(false);
  const [excelParams, setExcelParams] = useState({});

  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);
  const [financeScraping, setFinanceScraping] = useState({});

  // 메일주소 입력 modal open
  const [mailOpen, setMailOpen] = useState(false);

  const timerId = useRef(null);

  const [isExcelDown, setIsExcelDown] = useState(false);

  useEffect(() => {
    setFields([
      {
        title: "거래일자",
        key: "tradeTime",
        onValue: (value) => {
          return (
            <div className="date-wrap">
              <p className="date">{dateToViewFormat(value)}</p>
              <p className="time">{getFormatHour(value)}</p>
            </div>
          );
        },
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "입금액",
        key: "inAmt",
        className: "color-red-100",
        type: "comma",
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "출금액",
        key: "outAmt",
        className: "color-purple-100",
        type: "comma",
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "잔액",
        key: "balanceAmt",
        type: "comma",
        sort: (key) => handleSort(key), order: (key) => orderKey(key)
      },
      {
        title: "거래자명", key: "traderName"
      },
      {
        title: "입금자명", key: "sendBankAccountHolder"
      },
      {
        title: "적요", key: "remark"
      },
      {
        title: "적요(상세)", key: "detail"
      },
      {
        title: "메모", key: "memo"
      },
      {
        title: '',
        key: 'comments',
        onValue: (value) => {
          return (
            !isEmpty(value) ? (
              <>
                <Icon src={CommentIcon} />
                <span className="ml-4 font-bold">{value.count}</span>
              </>
            ) : (<></>)
          );
        }
      },
      {
        title: "거래처",
        key: "clients",
        className: "text-align-right",
        onValue: (value, field, data) => {
          return (
            !isEmpty(value) &&
            value.map((client, idx) => (
              <p className="pt-8 pb-8" key={idx}
              /*
                onClick={(e) => {
                  preventEvent(e);
                  client.companyAccount && clientPreview(client.companyAccount.idx);
                }} 
                */
              >
                <span className="vertical-middle"
                  onClick={(e) => {
                    preventEvent(e);
                    client.companyAccount && clientPreview(client.companyAccount.idx);
                  }}>{client.name}
                </span>
                {permission.level > 1 && (
                  <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveClient(data, client)} />)}
              </p>
            ))
          );
        }
      },
      {
        title: '카테고리',
        key: 'accountingTitleUses',
        className: "text-align-right",
        onValue: (value) => {
          return (
            !isEmpty(value) &&
            value.map((category, idx) => (
              <p className="pt-8 pb-8" key={idx}>
                <span className="vertical-middle">{category.accountingTitle.name}</span>
                {permission.level > 1 && (
                  <IconButton className="ml-4 vertical-middle" icon={DeleteIcon} action={() => handleRemoveCategory(category)} />)}
              </p>
            ))
          );
        }
      }
    ]);
  }, [sortFields]);

  useEffect(() => {
    if (!relatedListOpen) {
      setSelectedList([]);
    }
  }, [relatedListOpen]);

  useEffect(() => {
    if (scrapingPermission) {
      const _bankData = bankList.find((b) => b.idx === bankAccountIdx);
      if (!isEmpty(_bankData)) {
        let scrapings = [];
        if (_bankData.orgCd === "pbk") {
          scrapings = pbkScrapings;
        } else if (_bankData.orgCd === "cbk") {
          scrapings = cbkScrapings;
        }
        const scraping = scrapings.find(f => f.orgCd === _bankData.orgCd && f.acctNo === _bankData.accountNo);
        setFinanceScraping(scraping);
      }
    }
  }, [scrapingPermission, pbkScrapings, cbkScrapings]);

  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);

  useEffect(() => {
    if (timerValue === 1 && !isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      setTimerValue(0);
      if (reload && !isEmpty(financeScraping)) {
        getHistories(financeScraping);
      }
    }
  }, [timerValue]);

  const getHistories = (financeScraping) => {
    getFinanacesScrapingHistoryList(financeScraping.idx, { search: { state: 9 } })
      .then(res => {
        if (!isEmpty(res.data.histories)) {
          setReload(true);
          setIsScraping(true);
        } else {
          setReload(false);
          setIsScraping(false);
          reSubmit(form);
        }
      });
  };

  useEffect(() => {
    if (!isEmpty(financeScraping)) {
      getHistories(financeScraping);
    }
  }, [financeScraping]);

  const {
    form,
    setForm,
    setSubmit,
    // LIST 용
    filterSubmit,
    reSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    setOrderBy
  } = useForm(
    {
      ...params,
      page: 0,
      limit: 10,
      bankAccountIdx
    },
  );

  useEffect(() => {
    const sortField = sortFields.find((field) => !isEmpty(field.order));
    if (sortField) {
      setOrderBy(sortField);
    }
  }, [sortFields]);

  useEffect(() => {
    setSubmit(submit);
  }, []);

  useEffect(() => {
    if (!isEmpty(params)) {
      const _params = {
        ...form,
        ...params,
        bankAccountIdx
      };
      setForm(_params);
      filterSubmit({
        params: _params
      });
    }
  }, [bankList, bankAccountIdx]);

  const submit = (params = {}) => {
    const _params = cloneDeep(params);
    if (_params.clientRegistered) {
      _params.clientRegistered = false;
    } else {
      delete _params.clientRegistered;
    }
    if (_params.categoryRegistered) {
      _params.categoryRegistered = false;
    } else {
      delete _params.categoryRegistered;
    }

    setExcelParams(_params);
    const body = getParams(_params);
    if (isUseConfirm) {
      if (!body.search) body.search = {};
      body.search.useConfirm = true;
    }

    api(body)
      .then((response) => {
        const { transTotal, trans = [], comment = {} } = get(response, "data.bankAccounts[0]", {});
        const transList = trans.map((t) => ({
          ...t,
          comments: comment.listByPost?.find(c => c.postIdx === t.idx) || {}
        }));
        setTotal(transTotal);
        setList(transList);
      })
      .finally(() => setIsLoading(false));
  };

  const tableButtons = [
    {
      label: "거래처 일괄등록",
      color: "gray-line",
      action: () => {
        setIsClientMappingOpen(true);
      },
      disabled: isEmpty(selectedList)
    },
    {
      label: "카테고리 일괄등록",
      color: "gray-line",
      action: () => {
        setIsCategoryMappingOpen(true);
      },
      disabled: isEmpty(selectedList)
    },
    // {
    //   label: "관련내역 일괄등록",
    //   color: "gray-line",
    //   action: () => {
    //     setRelatedListOpen(true)
    //   },
    //   disabled: isEmpty(selectedList)
    // },
    {
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      color: "gray-line",
      action: () => {
        const _params = {
          idx: excelParams.bankAccountIdx,
          range: {
            tradeTime: {
              from: excelParams.range.tradeTime[0],
              to: excelParams.range.tradeTime[1]
            },
          },
          search: excelParams.search,
          //...excelParams.search.clientName ? { search: excelParams.search } : {}
        };

        const _bankData = bankList.find((b) => b.idx === bankAccountIdx);



        if (form.checkingType) {
          _params.checkingType = form.checkingType;
        }

        const body = getExcelDownParams(_params);

        let fileName = "입출금 내역";
        if (isUseConfirm) {
          if (!body.search) body.search = {};
          body.search.useConfirm = true;
          fileName = "내역확인 요청목록";
        }
        setIsExcelDown(true);
        downloadBankAccountexcel(body).then((res) => {
          downExcelFile(res, `${_bankData.bankCompany}(${_bankData.accountNo.substr(_bankData.accountNo.length - 5)}) ${fileName}.xlsx`);
        }).finally(() => setIsExcelDown(false));
      },
      disabled: isEmpty(list) || isExcelDown
    },
    {
      label: "거래내역 스크래핑",
      disabled: isScraping,
      isHide: isEmpty(financeScraping) || isEmpty(scrapingPermission) || 1 >= scrapingPermission.level,
      action: () => {
        systemAlert("수동 스크래핑을 진행하시겠습니까?", {
          buttons: [
            {
              label: "취소",
              color: "text"
            }, {
              label: "스크래핑",
              onClick: () => {
                const params = {
                  svcCd: "B0002",
                  sdate: dateToFormat(new Date(), 'YYYYMMDD'),
                  edate: dateToFormat(new Date(), 'YYYYMMDD')
                };
                viewLoading(true);
                scrapingFinanaces(financeScraping.idx, params)
                  .then(() => {
                    setReload(true);
                    setIsScraping(true);
                    systemAlert(
                      <>
                        <p>스크래핑 요청에 성공하였습니다.</p>
                        <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                        <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                        <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                        <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                      </>
                      , {
                        buttons: [
                          {
                            label: "수집이력 확인하기",
                            onClick: () => {
                              history.push("/manager/financial?tab=scraping-history");
                            }
                          },
                          {
                            label: "확인",
                            onClick: () => {
                              getHistories(financeScraping);
                            }
                          },
                        ]
                      });
                  })
                  .catch(() => { })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }
          ]
        });
      }
    }
  ];

  const handleRowClick = (data, e) => {
    const { tagName } = e.target;
    if (tagName !== "TR" && tagName !== "TD") return;
    setDetailFromData(data);
    setOpen(true);
  };

  const rowBtnConfig = {
    title: '거래처 매핑 / 카테고리 매핑 / 내역확인요청',
    rowButtons: [
      {
        // 거래처 매핑
        type: "edit",
        className: "mr-4",
        action: (data) => {
          setIsClientMappingOpen(true);
          setSelectedList([data]);
        },
      },
      {
        // 카테고리 매핑
        type: "edit",
        className: "ml-4",
        action: (data) => {
          setIsCategoryMappingOpen(true);
          setSelectedList([data]);
        },
      },
      {
        // 내역 확인 요청
        type: "check",
        className: (data) => {
          return classnames('ml-4', {
            checked: data.useConfirm
          });
        },
        action: (data) => {
          modifyBankTransUseConfirm(data.idx, !data.useConfirm);
          setList(list.map((item) => ({
            ...item,
            useConfirm: item.idx === data.idx ? !item.useConfirm : item.useConfirm
          })));
        },
      },
    ],
  };

  const handleRemoveClient = (data, client) => {
    const bankIdx = data.idx;
    const clientIdx = client.idx;

    systemAlert(`은행내역에 매핑된 거래처(${client.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteBanksTransClients(bankIdx, clientIdx)
              .then(() => {
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  const handleRemoveCategory = (category) => {
    systemAlert(`은행내역에 매핑된 카테고리(${category.accountingTitle.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteAccountingTitle(category.idx)
              .then(() => {
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  const getCheckboxDisabled = (data) => {
    let disabled = false;
    /*
        if (!isEmpty(selectedList) && selectedList[0].inAmt === 0)
        {
          if (data.inAmt !== 0)
          {
            disabled = true
          }
        }
        if (!isEmpty(selectedList) && selectedList[0].outAmt === 0)
        {
          if (data.outAmt !== 0)
          {
            disabled = true
          }
        }
    */
    return disabled;
  };

  const handleSort = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    const idx = findIndex(sortFields, sortField);
    let newArray = [...sortFields.map((field) => ({
      ...field,
      order: field.key !== key ? '' : field.order
    }))];
    newArray[idx] = {
      key,
      order: newArray[idx].order !== 'desc' ? 'desc' : 'asc'
    };
    setSortFields(newArray);
  };

  const orderKey = (key) => {
    const sortField = sortFields.find(field => field.key === key);
    return sortField.order;
  };

  const sendMailRquest = (email) => {
    const _params = {
      idx: excelParams.bankAccountIdx,
      range: {
        tradeTime: {
          from: excelParams.range.tradeTime[0],
          to: excelParams.range.tradeTime[1]
        },
      },
      search: excelParams.search,
      //...excelParams.search.clientName ? { search: excelParams.search } : {}
    };

    const body = getExcelDownParams({ ..._params, isSendMail: true, email });
    if (isUseConfirm) {
      if (!body.search) body.search = {};
      body.search.useConfirm = true;
    }

    getBankTransRecordExcelMailSend(body)
      .then(() => {
        systemAlert("메일 전송요청이 완료되었습니다.\n메일 수신함 확인 부탁드립니다.", {
          buttons: [
            {
              label: '확인',
              onClick: () => {
                setMailOpen(false);
              }
            }
          ]
        });
        setMailOpen(false);
      });
  };

  return (
    <>
      <ControlTable
        isControl={permission.level > 1}
        //isHideAllCheck
        checkboxDisabled={getCheckboxDisabled}
        isLoading={isLoading}
        isOpenToggle={true}
        title={title()}
        fields={fields}
        sortField={sortFields.find((field) => !isEmpty(field.order))}
        list={list}
        buttons={permission.level > 1 ? tableButtons : []}
        selectedList={selectedList}
        setSelected={setSelectedList}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        onSelect={handleRowClick}
        rowBtn={permission.level > 1 ? rowBtnConfig : {}}
      />
      <BankDetail
        permission={permission}
        open={open}
        setOpen={setOpen}
        formData={detailFormData}
        setFormData={setDetailFromData}
        listSubmit={reSubmit}
        type={"bank"}
        careCompanyIdx={careCompanyIdx}
      />
      {isClientMappingOpen && !isEmpty(selectedList) && (
        <ClientMappingModal
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          selected={selectedList}
          setSelected={setSelectedList}
          submit={() => reSubmit(form)}
        />
      )}
      {isCategoryMappingOpen && !isEmpty(selectedList) && (
        <CategoryMappingModal
          open={isCategoryMappingOpen}
          setOpen={setIsCategoryMappingOpen}
          selectedItem={selectedList}
          setSelectedItem={setSelectedList}
          useType="bank_trans"
          submit={() => reSubmit(form)}
          fields={fields.slice(0, 5)}
        />
      )}
      {relatedListOpen && (
        <RelatedModal
          open={relatedListOpen}
          setOpen={setRelatedListOpen}
          bankData={selectedList}
          submit={() => reSubmit(form)}
        />
      )}

      {mailOpen && (
        <EmailSendModal
          open={mailOpen}
          setOpen={setMailOpen}
          submit={sendMailRquest}
        />
      )}
    </>

  );
};

export default BankTable;
